import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-start-review-panel',
  templateUrl: './start-review-panel.component.html',
  styleUrls: ['./start-review-panel.component.scss'],
})
export class StartReviewPanelComponent {
  stars = Array(5);
  selected = 0;
  @Input() list: any = [];
  @Input() label = '';
  selectedDetails: string[] = [];

  @Output() rateChange = new EventEmitter<{
    rate: number;
    details: string[];
  }>();

  selectStar(value: any) {
    this.selected = value;
    this.selectedDetails = [];
    this.emitChange();
  }

  toggleDetail(item: string) {
    if (this.selectedDetails.includes(item)) {
      this.selectedDetails = this.selectedDetails.filter((d) => d !== item);
    } else {
      this.selectedDetails.push(item);
    }
    this.emitChange();
  }

  emitChange() {
    this.rateChange.emit({
      rate: this.selected,
      details: this.selectedDetails,
    });
  }
}
